export { default, type QuestionsSectionProps } from './QuestionsSection';
